<template>
  <main-right title="流水明细">
    <el-main class="page_content">
      <div class="gene_info">
        <div class="f_item">
          账户余额：<span class="remain">￥&nbsp;{{balance | fmtMoney(1)}}</span>
        </div>
        <div>
          统计日期：
          <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            :editable="false"
            :clearable="false"
            prefix-icon="iconfont icon-rili">
          </el-date-picker>
        </div>
      </div>
      <div class="cash_info">
        <div class="cash_box flex_box">
          <div class="item">
            <el-checkbox v-model="cashChecked" :disabled="!grantChecked"></el-checkbox>
            <span class="title">现金：</span>
            <span :class="[cashChecked?'red':'grey']">￥&nbsp;{{cash+contractCash  | fmtMoney(1e3)}}</span>
          </div>
          <div class="line"></div>
          <div class="item">
            <el-checkbox v-model="grantChecked" :disabled="!cashChecked"></el-checkbox>
            <span class="title">赠款：</span>
            <span :class="[grantChecked?'red':'grey']">￥&nbsp;{{grant+contractGrant | fmtMoney(1e3)}}</span>
          </div>
        </div>
        <div class="cash_box flex_box">
          <div class="check">
            <el-checkbox v-model="incomeChecked" :disabled="!expendChecked"></el-checkbox>
            <span class="title">充值</span>
          </div>
          <div class="line"></div>
          <div>
            <div class="item">
              <span>累计入账：</span>
              <span :class="[incomeChecked?'pink':'grey']">￥&nbsp;{{income||0 | fmtMoney(1e3)}}</span>
            </div>
          </div>
        </div>
        <div class="cash_box flex_box">
          <div class="check">
            <el-checkbox v-model="expendChecked" :disabled="!incomeChecked"></el-checkbox>
            <span class="title">支出</span>
          </div>
          <div class="line"></div>
          <div>
            <div class="item">
              <span>累计出账：</span>
              <span :class="[expendChecked?'blue':'grey']">￥&nbsp;{{expend | fmtMoney(1e3)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="page_box">
        <div>
          <el-collapse accordion @change="handleChange" v-model="activeName">
            <el-collapse-item v-for="item in monthList" class="col_box" :name="item.monthName" :key="item.monthName">
              <template slot="title">
                <div class="header">
                  <div style="float: left;font-weight: 500">{{item.monthName | isMonth}}</div>
                  <div style="float: right">
                  <span class="item">
                    <span>收入：</span>
                    <span class="pink">￥&nbsp;{{item.optTypeMap[1]||0 | fmtMoney(1e3)}}</span>
                  </span>
                    <span class="line"></span>
                    <span class="item">
                    <span>支出：</span>
                    <span class="blue">￥&nbsp;{{item.optTypeMap[2]||0 | fmtMoney(1e3)}}</span>
                  </span>
                  </div>
                </div>
              </template>
              <ul class="infinite-list"
                  v-if="detailList.length"
                  v-infinite-scroll="load"
                  infinite-scroll-disabled="disabled"
                  style="overflow:auto;max-height: 400px">
                <ColTable class="col" v-for="(item, i) in detailList" :key="i" :content="item" :code="{cashCode, grantCode, contractCashCode, contractGrantCode}"></ColTable>
              </ul>
              <div v-else class="nodata">暂无数据</div>
            </el-collapse-item>
            <!--          <el-collapse-item title="可控 Controllability">-->
            <!--            <div class="nodata">暂无数据</div>-->
            <!--          </el-collapse-item>-->
          </el-collapse>
        </div>
      </div>
    </el-main>
  </main-right>
</template>

<script>
  import moment from 'moment'
  import ColTable from './component/ColTable'
  import { getBill, getDetail } from '@/utils/customerApi'
  import { mapState } from 'vuex'

  export default {
    name: 'WaterDetail',
    components: { ColTable },
    filters: {
      // 判断是否为本月
      isMonth (v) {
        let nowDate = moment(new Date()).format('YYYY-MM')
        if (v === nowDate) {
          return '本月'
        }
        return v
      },
      fmtMoney (v, r) {
        if (v !== null) {
          if (v === 0) return '0.00'
          if (v !== undefined && !isNaN(v)) {
            let str = Number((v / r).toFixed(2)).toLocaleString()
            const dot = str.indexOf('.')
            if (dot >= 0) {
              let dec = str.slice(dot + 1, str.length)
              if (dec.length < 2) dec += '0'
              str = str.slice(0, dot + 1) + dec
            } else {
              str += '.00'
            }
            return str
          }
          return ''
        }
      }
    },
    data () {
      return {
        params: {}, // 获取指定月份流水明细接口参数
        monthList: [],
        detailList: [],
        loading: false,
        total: 0,
        startDate: '',
        endDate: '',
        dateRange: [],
        monthName: '',
        cashChecked: true,
        grantChecked: true,
        incomeChecked: true,
        expendChecked: true,
        info: {}, // 账户资料
        activeName: '',
      }
    },
    watch: {
      dateRange (v) {
        // 终止日期+1天
        console.log(v, 'date')
        let dateArr = v[1].split('-')
        this.startDate = v[0]
        this.endDate = moment([dateArr[0], dateArr[1] - 1, dateArr[2]]).add(1, 'days').format('YYYY-MM-DD')
        this.getList(1)
      },
      createTime: {
        immediate: true,
        handler (v) {
          if (v) {
            let nowDate = moment(new Date()).format('YYYY-MM-DD')
            this.dateRange = [v, nowDate]
          }
        }
      },
      userId () {
        this.getList(1)
      },
      accountId () {
        this.getList()
        this.handleChange(this.monthName)
      },
      optType (v) {
        this.getList()
        this.handleChange(this.monthName)
        console.log(v, 'opt')
      }
    },
    computed: {
      ...mapState({
        codeInfo: s => {
          return s.customer.codeInfo
        },
      }),
      cashCode () {
        return this.codeInfo.cashCode || 0
      },
      grantCode () {
        return this.codeInfo.grantCode || 0
      },
      contractCashCode () {
        return this.codeInfo.contractCashCode || 0
      },
      contractGrantCode () {
        return this.codeInfo.contractGrantCode || 0
      },
      // 筛选账号类型
      accountId () {
        if (this.cashChecked && !this.grantChecked) {
          return this.cashCode + ',' + this.contractCashCode
        } else if (this.grantChecked && !this.cashChecked) {
          return this.grantCode + ',' + this.contractGrantCode
        } else {
          return ''
        }
      },
      // 操作类型
      optType () {
        if (this.incomeChecked && !this.expendChecked) {
          return 1
        } else if (this.expendChecked && !this.incomeChecked) {
          return 2
        } else {
          return 0
        }
      },
      // 现金
      cash () {
        if (this.monthList.length) {
          return this.monthList[0].balanceMap[this.cashCode] || 0
        }
        return 0
      },
      // 赠款
      grant () {
        if (this.monthList.length) {
          return this.monthList[0].balanceMap[this.grantCode] || 0
        }
        return 0
      },
      // 合同现金
      contractCash () {
        if (this.monthList.length) {
          return this.monthList[0].balanceMap[this.contractCashCode] || 0
        }
        return 0
      },
      // 合同赠款
      contractGrant () {
        if (this.monthList.length) {
          return this.monthList[0].balanceMap[this.contractGrantCode] || 0
        }
        return 0
      },
      // 收入累加
      income () {
        let count = 0
        this.monthList.map(item => {
          count += item.optTypeMap[1] || 0
        })
        return count
      },
      // 支出累加
      expend () {
        let count = 0
        this.monthList.map(item => {
          count += item.optTypeMap[2] || 0
        })
        return count
      },
      noMore () {
        return this.detailList.length >= this.total
      },
      disabled () {
        return this.loading || this.noMore
      },
      balance () {
        return this.$store.state.customer.balanceInfo.balance
      },
      createTime () {
        return moment(this.$store.state.customer.userInfo.createTime).format('YYYY-MM-DD')
      },
      userId () {
        return this.$store.state.customer.userInfo.id
      }
    },
    beforeRouteLeave (to, from, next) {
      next()
    },
    async created () {
      // 获取现金和赠款的id
      this.$store.dispatch('customer/getAccBalance')
    },
    methods: {
      async load () {
        this.loading = true
        this.params.pageNum++
        console.log(this.params.pageNum)
        let res = await getDetail(this.params)
        if (res && res.code === 0) {
          this.detailList = this.detailList.concat(res.data.list)
          this.loading = false
        }
      },
      // 获取列表
      async getList (first) {
        if(!this.userId) return
        let param = {
          accountIds: this.accountId,
          startDate: this.startDate,
          endDate: this.endDate,
          optType: this.optType,
          userId: this.userId
        }
        let res = await getBill(param)
        if (res && res.code === 0) {
          this.monthList = res.data
          // 默认展开第一个
          if (this.monthList.length && first) {
            this.activeName = this.monthList[0].monthName || ''
            this.handleChange(this.activeName)
          }
        }
      },
      // 展开手风琴加载数据
      async handleChange (val) {
        this.monthName = val
        if (val) {
          this.params = {
            accountIds: this.accountId,
            userId: this.userId,
            startDate: this.startDate,
            endDate: this.endDate,
            optType: this.optType,
            monthName: val,
            pageNum: 1,
            pageSize: 20
          }
          let res = await getDetail(this.params)
          if (res && res.code === 0) {
            this.detailList = res.data.list
            this.total = res.data.total
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .top_tab {
    float: right;
    margin-top: 25px;
    margin-right: 20px;
  }
  .right_content {
    min-width: 1150px;
  }
  .page_content {
    background: #ffffff;
    padding: 0;
    height: 100%;
    .blue {
      color: #6296FF;
    }
    .red {
      color: #D50000;
    }
    .pink {
      color: #FF3973;
    }
    .green {
      color: #10C79E;
    }
    .grey {
      color: #C3C6D6;
    }
  }
  .gene_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    font-size: 14px;
    height: 70px;
    padding: 24px 20px;
    .f_item {
      font-size: 16px;
      color: #282729;
      font-weight: 500;
      font-family:PingFangSC-Medium,PingFang SC;
      .remain {
        font-size:20px;
        font-family:Akrobat-ExtraBold,Akrobat;
        font-weight:800;
        color:rgba(213,0,0,1);
      }
    }
  }
  .cash_info {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #F1F1F7;
    border-bottom: 1px solid #F1F1F7;
    .cash_box {
      width: 33%;
      border-right: 1px solid #F1F1F7;
      text-align: center;
      padding-top: 15px;
      padding-bottom: 15px;
      &:last-child {
        border-right: 0px;
      }
      .item {
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        line-height: 48px;
        .title {
          padding-right: 5px;
        }
      }
      .title {
        padding-left: 10px;
      }
    }
    .flex_box {
      display: flex;
      justify-content: center;
      .check {
        line-height: 48px;
      }
      .line {
        width: 1px;
        background: #EAEBF0;
        height: 12px;
        transform: translateY(18px);
        margin: 0 20px;
      }
    }
  }
  .page_box {
    background: #FFF;
    width: 100%;
    height: calc(100% - 150px);
    padding: 20px 40px 0;
    overflow: auto;
    .col_box {
      margin-bottom: 10px;
      .header {
        width: 100%;
        padding: 0 20px;
        .line {
          width: 1px;
          display: inline-block;
          background: #EAEBF0;
          height: 12px;
          transform: translateY(2px);
          margin: 0 20px;
        }
      }
      .col {
        margin-bottom: 1px;
      }
      .col:last-child {
        margin-bottom: 0;
      }
      .nodata {
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #ffffff;
        font-size: 14px;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: #3b3f45;
      }
    }
  }
  ::v-deep .el-date-editor--daterange.el-input__inner {
    width: 250px;
    .el-range-separator{
      width: 30px;
    }
  }
  ::v-deep .el-collapse{
    border: 0;
  }
  ::v-deep .el-collapse-item__header {
    background: rgba(250,250,250,1);
    border: 1px solid rgba(234,235,240,1);
    border-radius: 4px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(59,63,69,1);
  }
  ::v-deep .el-collapse-item__content {
    padding: 20px 20px;
    background: rgba(245,245,245,1);
  }
</style>
